import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import donateShadow from '../../assets/images/modal_buy/modal_buy_donate_shadow.png';
import shadow from '../../assets/images/modal_buy/modal_buy_shadow.png';
import moneyImage from '../../assets/images/shop_donate_money.png';

const StyledModalWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.85);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	width: 460px;
	padding: 30px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	box-shadow: 0 6px 80px rgba(0, 0, 0, 0.5);
`;

const StyledHeadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -300px;
	left: -300px;
	width: 600px;
	height: 600px;
	mask-image: url(${shadow});
	mask-size: 600px 600px;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: url(${shadow});
	-webkit-mask-size: 600px 600px;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	pointer-events: none;
`;

const StyledImageVehicleItemContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 200px;
	margin-top: 30px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	overflow: hidden;

	.collection-image {
		position: relative;
		z-index: 2;
	}
`;

const StyledSvg = styled.svg`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
`;

const StyledRarity = styled.div`
	position: absolute;
	top: 20px;
	left: 20px;
	width: 10px;
	height: 10px;
	border-radius: 10px;
`;

const StyledNameContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 30px;
`;

const StyledPriceContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 14px;
	gap: 10px;
	align-items: center;

	${Text} {
		font-size: 18px;
		color: #ffffff;

		&:nth-child(1) {
			opacity: 0.25;
		}

		&:nth-child(2) {
			font-weight: 700;
		}
	}
`;

const StyledDonateButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-size: 14px;
		font-weight: 700;
	}
`;

const StyledButtonsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 30px;
`;

const StyledItemType = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledDonateShadow = styled.div`
	width: 840px;
	height: 840px;
	position: absolute;
	top: -420px;
	left: 50%;
	transform: translateX(-50%);
	background-image: url(${donateShadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledBackNumbers = styled(Text)`
	font-size: 80px;
	line-height: 65px;
	font-weight: 700;
	color: #1f8034;
	opacity: 0.05;
	position: absolute;
	text-align: center;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1;
`;

const StyledMoneyImage = styled.div`
	position: absolute;
	width: 213px;
	height: 160px;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2;
	background-image: url(${moneyImage});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledDiscountTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}

	.divider {
		width: 1px;
		height: 20px;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledDiscountContainer = styled.div`
	padding: 3px 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledBadgesContainer = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
`;

export {
	StyledBackNumbers,
	StyledBadgesContainer,
	StyledButtonsGrid,
	StyledContainer,
	StyledDiscountContainer,
	StyledDiscountTimerContainer,
	StyledDonateButtonContent,
	StyledDonateShadow,
	StyledHeadContainer,
	StyledImageVehicleItemContainer,
	StyledItemType,
	StyledModalWrapper,
	StyledMoneyImage,
	StyledNameContainer,
	StyledPriceContainer,
	StyledRarity,
	StyledShadow,
	StyledSvg,
};
